export default (
  { background, foreground },
  { colors, mediaQuery, rhythm, scale }
) => ({
  root: {
    position: 'fixed',
    bottom: 0,
    left: 0,
    right: 0,
    padding: rhythm(1),
    backgroundColor: colors[background],
    color: colors[foreground],
    zIndex: 998,
    [mediaQuery('sm')]: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center'
    }
  },
  message: {
    marginBottom: rhythm(1),
    [mediaQuery('sm')]: {
      marginBottom: 0,
      marginRight: rhythm(1)
    }
  },
  link: {
    textDecoration: 'underline'
  },
  button: {
    display: 'block',
    width: '100%',
    [mediaQuery('sm')]: {
      width: 'auto',
      flexShrink: 0
    }
  }
})



// WEBPACK FOOTER //
// ./components/utils/CookieConsent/styles.js